import { RouteInfo } from './vertical-menu.metadata';

//Sidebar menu Routes and data
export const ROUTES: RouteInfo[] = [



  {
    path: '/page/home', title: 'Inicio', icon: 'ft-home', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], is_admin:false
  },

//  {
//    path: '', title: 'Resumen', icon: 'ft-bar-chart', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false, submenu: [
//      { path: '/page/call-dashboard', title: 'Llamadas', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
//      { path: '/page/rss-dashboard', title: 'Redes sociales', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
//      { path: '/page/visit-dashboard', title: 'Visitas', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },


//    ]
//  },
  
  {
    path: '', title: 'Reportar', icon: 'ft-plus-square', class: 'has-sub', badge: '', badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1', isExternalLink: false,
    submenu: [
      { path: '/page/call-form', title: 'Llamadas', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], is_admin:true },
      { path: '/page/rss-form', title: 'Redes sociales', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], is_admin:true },
      { path: '/page/visit-form', title: 'Visitas', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], is_admin:true },
      { path: '/page/client-form', title: 'Clientes', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], is_admin:true},



    ],
    is_admin:true
},
{
  path: '', title: 'Consultar', icon: 'ft-monitor', class: 'has-sub', badge: '', badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1', isExternalLink: false,
  submenu: [
    { path: '/page/call-consultation', title: 'Llamadas', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], is_admin:false },
    { path: '/page/rss-consultation', title: 'Redes sociales', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], is_admin:false },
    { path: '/page/visit-consultation', title: 'Visitas', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], is_admin:false },
    { path: '/page/client-consultation', title: 'Clientes', icon: '', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],is_admin:false }

  ],
  is_admin:false
}
];
